import { Injectable, computed, signal } from "@angular/core";
import type { AuthUser } from "../interfaces/auth.interface";

/**
 * Auth state service for cookie-based authentication.
 * Tokens are stored in HttpOnly cookies by the backend.
 * This service only tracks user info retrieved from the backend.
 */
@Injectable({ providedIn: "root" })
export class AuthStateService {
  private readonly _user = signal<AuthUser | undefined>(undefined);

  readonly user = computed(() => this._user());
  readonly isAuthenticated = computed(() => this._user() !== undefined);

  setUser(user: AuthUser): void {
    this._user.set(user);
  }

  clearUser(): void {
    this._user.set(undefined);
  }
}
